// @ts-nocheck
(function initMetafieldList() {
  // The data map + container are injected lazily by product-description-tabs.js via the
  // Section Rendering API, so this can run before or after that injection happens.
  function getCurrentVariantId(data) {
    const variantInput = document.querySelector('[data-type="add-to-cart-form"] [name="id"]');
    return variantInput?.value || data.currentVariantId;
  }

  function setup() {
    const container = document.getElementById('metafield-list-container');
    const dataScript = document.getElementById('metafield-data-map');

    if (!container || !dataScript || container.dataset.metafieldListInitialized) return;
    container.dataset.metafieldListInitialized = 'true';

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Failed to parse metafield map JSON:', e);
      return;
    }

    // Format value safely in case value is an object/array from Liquid
    function formatValue(val) {
      if (val === null || val === undefined) return '';
      if (typeof val === 'object') {
        return val.value || val.label || JSON.stringify(val);
      }
      return String(val);
    }

    // Group and format metafield data for rendering
    function getGroupedMetafields(variantId) {
      // Force string conversion to match JSON object keys reliably
      let subjectId = String(variantId);

      if (data.isDefaultTitle || !data.metafieldsMap[subjectId]) {
        subjectId = String(data.productId);
      }

      const metafields = data.metafieldsMap[subjectId] || {};
      const entries = Object.values(metafields);

      let grouped = {};

      entries.forEach((item) => {
        if (!item) return;

        // Fallback group name if not explicitly set
        const groupName = item.group || 'General';

        if (!grouped[groupName]) {
          grouped[groupName] = [];
        }

        grouped[groupName].push({
          key: typeof item.key === 'object' ? item.key.value || item.key : item.key,
          value: formatValue(item.value),
        });
      });

      // Reorder so "Dimensions" appears first if present
      if (grouped['Dimensions']) {
        const ordered = { Dimensions: grouped['Dimensions'] };
        Object.keys(grouped).forEach((key) => {
          if (key !== 'Dimensions') {
            ordered[key] = grouped[key];
          }
        });
        grouped = ordered;
      }

      return grouped;
    }

    // Render DOM nodes
    function render(variantId) {
      if (!variantId) return;

      const grouped = getGroupedMetafields(variantId);
      container.innerHTML = '';

      const groupEntries = Object.entries(grouped);

      if (groupEntries.length === 0) {
        container.innerHTML = '<p class="metafield-empty">No detailed specifications available for this variant.</p>';
        return;
      }

      groupEntries.forEach(([groupName, items]) => {
        const groupDiv = document.createElement('div');
        groupDiv.className = 'metafield-group';

        const groupTitle = document.createElement('span');
        groupTitle.className = 'metafield-group-title';
        groupTitle.textContent = groupName;
        groupDiv.appendChild(groupTitle);

        const list = document.createElement('ul');
        list.className = 'metafield-group-list';

        items.forEach((item) => {
          const listItem = document.createElement('li');
          listItem.className = 'metafield-item';

          const keySpan = document.createElement('span');
          keySpan.className = 'metafield-key';
          keySpan.textContent = item.key;

          listItem.appendChild(keySpan);
          listItem.appendChild(document.createTextNode(`: ${item.value}`));
          list.appendChild(listItem);
        });

        groupDiv.appendChild(list);
        container.appendChild(groupDiv);
      });
    }

    // Initial render, preferring the live selected variant over the variant that happened to be
    // current when this section was fetched (they can drift if the shopper switched variants
    // before ever opening this tab).
    render(String(getCurrentVariantId(data)));

    // Global event listener for custom and theme variant changes
    function handleVariantUpdate(id) {
      if (id) render(String(id));
    }

    // 1. Listen for ProductSelectEvent
    document.addEventListener('ProductSelectEvent', (event) => {
      if (event.detail?.promise) {
        event.detail.promise.then((result) => {
          const variantId = result?.variant?.id || result?.detail?.resource?.id;
          handleVariantUpdate(variantId);
        });
      }
    });

    // 2. Fallback event for custom 'variant:change'
    window.addEventListener('variant:change', (event) => {
      const variantId = event.detail?.variant?.id || event.detail?.variant;
      handleVariantUpdate(variantId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Fired by product-description-tabs.js once it has lazily fetched and injected this panel's
  // markup via the Section Rendering API.
  document.addEventListener('lazy-section:loaded', (event) => {
    if (event.detail?.sectionId === 'product-metafields-panel') setup();
  });
})();
